<script>

export default {

  name: "HomePage",
  data: () => {
    return {
      welcomeImage: require("@/assets/slider-img.png"),
    }
  },
  methods: {}
}


</script>

<template>
  <div class="scene">
    <img class="welcomeImage noselect" :src="welcomeImage" >
    <h2></h2>
  </div>
</template>

<style scoped>
.welcomeImage {
  height: 70vh;

}
</style>